// extracted by mini-css-extract-plugin
export var configurationSection = "_rp-0";